var map = {
	"./hall_a.png": 70,
	"./hall_b.png": 71,
	"./hall_c.png": 72,
	"./hall_d.png": 73,
	"./hall_e.png": 74,
	"./hall_f.png": 75,
	"./hall_g.png": 76,
	"./hall_h.png": 77,
	"./hall_i.png": 78,
	"./hall_j.png": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;